import type { Substance } from '../pharmacology/types';
import { computeDoseResponse, type DoseResponseResult } from './doseResponse';

/**
 * Plain-data holder for the current substance/dose/time selection. No
 * rendering dependencies — main.ts reads `compute()` output and decides how
 * to translate it into visuals.
 */
export class SimulationState {
  substance: Substance | null = null;
  doseOrReleaseLevel = 0;
  timeHours = 1;

  setSubstance(substance: Substance | null): void {
    this.substance = substance;
  }

  setDoseAndTime(doseOrReleaseLevel: number, timeHours: number): void {
    this.doseOrReleaseLevel = doseOrReleaseLevel;
    this.timeHours = timeHours;
  }

  compute(): DoseResponseResult | null {
    if (!this.substance || this.doseOrReleaseLevel <= 0) return null;
    return computeDoseResponse(this.substance, this.doseOrReleaseLevel, this.timeHours);
  }
}
